import React, { useContext } from "react"
import { DashboardContext } from "./DashboardContext"
import { TableView } from "../reports/TableView"
import { GraphView } from "../reports/GraphView"

export const ReportView = () => {
  const { selectedExamId, reportView, student, setReportView } = useContext(DashboardContext)
  return (
    selectedExamId && (
      <>
        <div className="card mt-3 shadow-sm">
          <div className="card-header">
            <button
              className="btn btn-primary mx-1"
              style={reportView === "table" ? { background: "#00388D" } : {}}
              onClick={() => setReportView("table")}>
              <i className="fa fa-list"></i> Table View
            </button>
            <button
              className="btn btn-primary mx-1"
              style={reportView === "graph" ? { background: "#00388D" } : {}}
              onClick={() => setReportView("graph")}>
              <i className="fa fa-bar-chart"></i> Graph View
            </button>
          </div>
        </div>

        <div className="mt-3 shadow-sm">
          {reportView === "table" && (
            <>
              <TableView studentId={student?.id} examId={selectedExamId} />
            </>
          )}
        </div>
        {reportView === "graph" && (
          <>
            <GraphView studentId={student?.id} examId={selectedExamId} />
          </>
        )}
      </>
    )
  )
}
